export var TabVariant = /*#__PURE__*/ function(TabVariant) {
    TabVariant["brand"] = "brand";
    TabVariant["gray"] = "gray";
    TabVariant["underline"] = "underline";
    TabVariant["white"] = "white";
    TabVariant["minimal"] = "minimal";
    TabVariant["whiteTabFlat"] = "whiteTabFlat";
    return TabVariant;
}({});
export var Direction = /*#__PURE__*/ function(Direction) {
    Direction["vertical"] = "vertical";
    Direction["horizontal"] = "horizontal";
    return Direction;
}({});
export var TabSize = /*#__PURE__*/ function(TabSize) {
    TabSize["s"] = "s";
    TabSize["m"] = "m";
    return TabSize;
}({});
export var TriggerType = /*#__PURE__*/ function(TriggerType) {
    TriggerType["trigger"] = "trigger";
    TriggerType["group"] = "group";
    return TriggerType;
}({});
